module.exports = __webpack_public_path__ + "assets/images/logout.17003d185843b6ae372ac09913e0c5d5.svg";